import { BrokerExtensions } from "@primaria/plugins-core";
import { BrokerDisposableHandler } from "@uxland/primary-shell";
import { SetCustomFilterAllValues } from "./request";
import { SetCustomFilterAllValuesHandler } from "./handler";

let request: BrokerDisposableHandler;

export const bootstrapSetCustomFilterAllValues = (broker: BrokerExtensions) => {
  request = broker.registerRequest(SetCustomFilterAllValues, SetCustomFilterAllValuesHandler);
};

export const teardownSetCustomFilterAllValues = () => {
  request?.dispose();
};
